import request from '@/utils/http';

export const correctionOrderApi = (params) => {
    return request({
        url: `api-otp/alterAddressError`,
        method: 'get',
        params
    });
};

export const addSiteApi = (params) => {
    return request({
        url: `/anapi-oms/searchagg/gis/gisHistory/add`,
        method: 'post',
        data: params
    });
};

export const correctionApi = (params) => {
    return request({
        url: `api-gis/gisHistoryInfos`,
        method: 'post',
        data: params
    });
};

export const gisPolygonApi = (params) => {
    return request({
        url: `/anapi-oms/searchagg/gis/getAreaByPoint`,
        method: 'post',
        data: params
    });
};

export const getGisInfoApi = (params) => {
    return request({
        url: `anapi-oms/searchagg/gis/selectGisPolygonInfoByButton`,
        method: 'get',
        params
    });
};
/**
 * 获取GIS历史数据
 * @param params 对象参数，包含以下属性：
 *    pageNo: 当前页码
 *    pageSize: 每页显示数量
 *    address: 查询地址
 *    startTime: 查询开始时间
 *    endTime: 查询结束时间
 * @returns 返回请求结果
 */
export const getGisHistory = (params) => {
    return request({
        url: `anapi-oms/searchagg/gis/gisRectInfos`,
        method: 'post',
        data: params
    });
};
